var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 50,
    viewBox: "0 0 201 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.4762H2.85106C5.70213 15.4762 12.8298 15.4762 18.5319 16.6667C24.234 17.8571 29.9362 21.4286 37.0638 25C42.766 28.5714 48.4681 32.1429 54.1702 32.1429C61.2979 32.1429 67 28.5714 72.7021 23.8095C79.8298 17.8571 85.5319 11.9048 91.234 13.0952C96.9362 13.0952 104.064 21.4286 109.766 26.1905C115.468 29.7619 121.17 29.7619 128.298 26.1905C134 23.8095 139.702 16.6667 146.83 14.2857C152.532 11.9048 158.234 13.0952 163.936 16.6667C171.064 20.2381 176.766 25 182.468 22.619C188.17 20.2381 195.298 9.52381 198.149 4.7619L201 0V50H198.149C195.298 50 188.17 50 182.468 50C176.766 50 171.064 50 163.936 50C158.234 50 152.532 50 146.83 50C139.702 50 134 50 128.298 50C121.17 50 115.468 50 109.766 50C104.064 50 96.9362 50 91.234 50C85.5319 50 79.8298 50 72.7021 50C67 50 61.2979 50 54.1702 50C48.4681 50 42.766 50 37.0638 50C29.9362 50 24.234 50 18.5319 50C12.8298 50 5.70213 50 2.85106 50H0V15.4762Z",
    fill: "url(#paint0_linear_203_1007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_1007",
    x1: 100.5,
    y1: 0,
    x2: 100.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A034FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A034FA",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph3);
export default __webpack_public_path__ + "static/media/graph3.b94d35776c2c9ceeddf7cab03ad99e4b.svg";
export { ForwardRef as ReactComponent };